import * as Types from '../gql/types2';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {"context":{"clientName":"graphql2"}} as const;
export type CreateProjectChargeMutationVariables = Types.Exact<{
  input: Types.CreateProjectChargeCommand;
}>;


export type CreateProjectChargeMutation = { __typename?: 'MutationModel', projectCharges: { __typename?: 'ProjectChargesMutationModel', createProjectCharge: { __typename?: 'CreateProjectChargeResponse', projectChargeId?: number | null, errors: Array<{ __typename?: 'ValidationError', argumentName?: string | null, message: string }> } } };


export const CreateProjectChargeDocument = gql`
    mutation CreateProjectCharge($input: CreateProjectChargeCommand!) {
  projectCharges {
    createProjectCharge(input: $input) {
      errors {
        argumentName
        message
      }
      projectChargeId
    }
  }
}
    `;
export type CreateProjectChargeMutationFn = Apollo.MutationFunction<CreateProjectChargeMutation, CreateProjectChargeMutationVariables>;

/**
 * __useCreateProjectChargeMutation__
 *
 * To run a mutation, you first call `useCreateProjectChargeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProjectChargeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProjectChargeMutation, { data, loading, error }] = useCreateProjectChargeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProjectChargeMutation(baseOptions?: Apollo.MutationHookOptions<CreateProjectChargeMutation, CreateProjectChargeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProjectChargeMutation, CreateProjectChargeMutationVariables>(CreateProjectChargeDocument, options);
      }
export type CreateProjectChargeMutationHookResult = ReturnType<typeof useCreateProjectChargeMutation>;
export type CreateProjectChargeMutationResult = Apollo.MutationResult<CreateProjectChargeMutation>;
export type CreateProjectChargeMutationOptions = Apollo.BaseMutationOptions<CreateProjectChargeMutation, CreateProjectChargeMutationVariables>;